import { addDays } from 'date-fns';
import fromPairs from 'lodash/fromPairs';

const ENV = import.meta.env.VITE_APP_ENV === 'prod' ? 'bizly_authentication_token' : 'dev_bizly_authentication_token';
const developmentDomain = window.location.hostname === 'localhost' || window.location.hostname.includes('.netlify');
const DOMAIN = developmentDomain ? '' : 'domain=.bizly.com;';
const newCookieString = (key: string, value: string, expiration: string) =>
    `${key}=${value}; path=/; ${DOMAIN} expires=${expiration}; secure=true;`;
const iarDevCookieString = (key: string, value: string, expiration: string) =>
    `${key}=${value}; path=/; domain=.bizly.com; expires=${expiration}; secure=true;`;

export const setCookie = (token: string) => {
    const today = new Date();
    const validExpirationDate = addDays(today, 3).toUTCString();

    document.cookie = newCookieString(ENV, token, validExpirationDate);
    if (import.meta.env.VITE_APP_ENV !== 'prod')
        document.cookie = iarDevCookieString('dev_bizly_auth_token', token, validExpirationDate);
};

type CookieObj = {
    [key: string]: string;
} & {
    [tokenCookie in typeof ENV]: string;
};

const parseCookie = () =>
    fromPairs(
        (document.cookie || '').split(';').map(cookieString =>
            cookieString
                .split('=')
                .map(cookieParts => cookieParts.trim())
                .map(decodeURIComponent)
        )
    ) as Partial<CookieObj>;

export const getCookie = () => {
    const cookies = parseCookie();
    const token = cookies[ENV];
    const hasToken = typeof token === 'string';

    return hasToken && token;
};

export const removeCookie = () => {
    const expiredDate = new Date(0).toUTCString();

    // List of all possible JWT cookies to remove
    const cookiesToRemove = [
        'bizly_authentication_token',
        'dev_bizly_auth_token',
        'dev_bizly_authentication_token',
        'bizly_auth_token',
        'development_bizly_access_token',
        'bizly_access_token',
        'production_bizly_access_token',
    ];

    // Remove specific cookies
    cookiesToRemove.forEach(cookieName => {
        // Remove from root path
        document.cookie = `${cookieName}=; path=/; expires=${expiredDate}; secure=true;`;

        // Remove from .bizly.com domain
        document.cookie = `${cookieName}=; path=/; domain=.bizly.com; expires=${expiredDate}; secure=true;`;
    });

    // Get all cookies
    const allCookies = parseCookie();

    // Remove any other cookies in the .bizly.com domain
    Object.keys(allCookies).forEach(cookieName => {
        if (cookieName.includes('bizly')) {
            document.cookie = `${cookieName}=; path=/; expires=${expiredDate}; secure=true;`;
            document.cookie = `${cookieName}=; path=/; domain=.bizly.com; expires=${expiredDate}; secure=true;`;
        }
    });
};
